package ai.flowstorm.studio.ui.design

import ai.flowstorm.common.id.Id
import ai.flowstorm.studio.model.Persona
import ai.flowstorm.studio.resources.space.PersonaResource
import ai.flowstorm.common.ui.*
import ai.flowstorm.core.video.VideoPreviewRequest
import ai.flowstorm.studio.model.Enum
import ai.flowstorm.studio.ui.form.DialogueId
import ai.flowstorm.studio.ui.form.SpeechRecognizerId
import ai.flowstorm.studio.ui.form.VoiceId
import io.kvision.core.Resize
import io.kvision.form.check.CheckBox
import io.kvision.form.select.Select
import io.kvision.form.text.Text
import io.kvision.form.text.TextArea
import io.kvision.html.Button
import io.kvision.html.Div
import io.kvision.i18n.tr

class PersonaForm : EntityForm<Persona>(PersonaResource) {

    val containerId = "flvVideoContainer"
    private lateinit var previewDiv: Div
    private lateinit var previewButton: Button
    private var previewUrl: TextArea =
        TextArea(rows = 1, label = tr("URL")) {
            disabled = true
            input.resize = Resize.NONE
        }
    private lateinit var previewText: TextArea

    private val voice = VoiceId().apply {
        load(null)
    }
    private val speechRecognizer = SpeechRecognizerId().apply {
        load(null)
    }

    init {
        add(
            Persona::name,
            Text(label = tr("Name")),
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Persona::publicName,
            Text(label = tr("Public name"))
        )
        add(
            Persona::description,
            TextArea(label = tr("Description"), rows = 3),
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Persona::publicDescription,
            TextArea(label = tr("Public description"), rows = 3)
        )
        add(
            Persona::gender,
            Select(label = tr("Gender"), options = UiHelpers.options(Enum.genders)),
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Persona::isStrong,
            CheckBox(label = tr("Strong"))
        )
        add(
            Persona::icon,
            Text(label = tr("Icon")),
        )
        add(
            Persona::background,
            Text(label = tr("Background")),
        )
        add(
            Persona::avatarId,
            Text(label = tr("Avatar ID")),
            required = true,
            requiredMessage = tr("Required field"),
        )
        add(
            Persona::dialogue_id,
            DialogueId(label = tr("Implicit Dialogue")),
        )
        add(
            Persona::brain_id,
            DialogueId(label = tr("Brain Dialogue")),
        )
        add(
            Persona::voice_id,
            voice,
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Persona::speechRecognizer_id,
            speechRecognizer
        )
        add(
            VideoPreview(
                withForm = false,
                mainScope = mainScope,
                getOptions = {
                return@VideoPreview VideoPreviewRequest(
                    form.fields["avatarId"]?.getValue() as String,
                    form.fields["voice_id"]?.getValue() as Id,
                    ""
                    )
                }
            )
        )
    }
}
